// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import classnames from 'classnames'
import { PopUp, PrimaryButton, CharacterLimitCounter, ErrorAlert } from 'ui_kit_qmd'
import { SecondaryButton } from '../../../components/ui_kit_quickMD/secondary-button/secondarybutton'
import { errorCodes, getUserFriendlyErrorMessage } from '../../../utils/errormessages'
import { resolveVisit } from '../../../store/visits/VisitsActions'
import errorIcon from '../../../images/common/error-icon.svg'
import closeIcon from '../../../images/common/close.png'
import './resolveVisitPopUp.scss'

const secondaryBtnContainerStyle = {
  height: 58,
  width: 282,
  border: '1px solid #00a2b2',
  borderRadius: '4px',
  padding: 0,
}
const primaryBtnContainerStyle = {
  height: 60,
  width: 284,
  marginLeft: 24,
  borderRadius: '4px',
}

const secondaryBtnLabelStyle = {
  fontSize: 20,
  fontWeight: 700,
  gap: 10,
  letterSpacing: 1.5,
}

const primaryBtnLabelStyle = {
  fontSize: 20,
  gap: 10,
  letterSpacing: 1.5,
}

const popUpContainerStyle = { position: 'fixed', top: 0, bottom: 0, left: 0, right: 0 }
const popUpBoxStyle = { width: '925px', height: '498px', padding: '85px', boxSizing: 'border-box' }

const alertStyleContainer = { position: 'fixed', zIndex: 999999999 }

const DESCRIPTION_LIMIT = 200
const TEXTAREA_PLACEHOLDER = 'Type a description*'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const ResolveVisitPopUp = ({ close, visitId }) => {
  const dispatch = useDispatch()

  const [textareaValue, setTextareaValue] = useState('')
  const [fieldErrorValue, setFieldErrorValue] = useState('')
  const [toastError, setToastError] = useState('')

  useEffect(() => {
    // @ts-expect-error TS7034 -- MIGRATION: not approved, fix when encountered
    let timeoutId
    if (toastError) {
      timeoutId = setTimeout(() => {
        if (toastError) {
          setToastError('')
        }
      }, 3500)
    }

    return () => {
      // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
      if (timeoutId) {
        window.clearTimeout(timeoutId)
      }
    }
  }, [toastError])
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  const onChange = ({ target }) => {
    if (fieldErrorValue) {
      setFieldErrorValue('')
    }

    setTextareaValue(target?.value)
  }

  const onSubmit = () => {
    const value = (textareaValue || '').trim()

    let fieldError = ''
    if (!value) {
      fieldError = getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Description')
    } else if (value.length > DESCRIPTION_LIMIT) {
      fieldError = getUserFriendlyErrorMessage(errorCodes.MAX_CHARACTER_LIMIT)
    }

    if (fieldError) {
      setFieldErrorValue(fieldError)
      setToastError(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS))
    } else {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(resolveVisit({ visitId, description: value }))
      close()
    }
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onTextareaFocus = (event) => {
    event.target.placeholder = ''
  }
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onTextareaBlur = (event) => {
    event.target.placeholder = TEXTAREA_PLACEHOLDER
  }

  return (
    <PopUp
      popUpContainerStyle={popUpContainerStyle}
      popUpBoxStyle={popUpBoxStyle}
      content={
        <>
          {!!toastError && (
            <ErrorAlert
              errorText={toastError}
              errorImg={errorIcon}
              imgAlt='errorIcon'
              styleContainer={alertStyleContainer}
            />
          )}

          <div className='resolve-visit-popup'>
            <img role='presentation' alt='Close' src={closeIcon} className='select-mode-close-icon' onClick={close} />
            <h1 className='resolve-visit-popup-title'>Resolved visit</h1>
            <div className='resolve-visit-popup-text'>You must describe how you resolved the visit.</div>
            <div className='resolve-visit-popup-textarea'>
              <textarea
                className={classnames('textarea-element', {
                  'textarea-element-error': !!fieldErrorValue,
                })}
                placeholder={TEXTAREA_PLACEHOLDER}
                onFocus={onTextareaFocus}
                onBlur={onTextareaBlur}
                onChange={onChange}
                name='textarea'
                value={textareaValue}
              />
              {fieldErrorValue ?
                <div className='textarea-error-message'>{fieldErrorValue}</div>
              : null}
              <CharacterLimitCounter
                currentAmount={textareaValue.length}
                limit={DESCRIPTION_LIMIT}
                isHighlightError={textareaValue.length > DESCRIPTION_LIMIT}
              />
            </div>
            <div className='resolve-visit-popup-actions'>
              {/*
               // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered */}
              <SecondaryButton
                id='viewServiceCancelEditBtn'
                btnText='Cancel'
                containerStyle={secondaryBtnContainerStyle}
                labelStyle={secondaryBtnLabelStyle}
                onPress={close}
              />
              <PrimaryButton
                btnText='Save'
                id='viewServiceSaveEditBtn'
                containerStyle={primaryBtnContainerStyle}
                labelStyle={primaryBtnLabelStyle}
                onPress={onSubmit}
              />
            </div>
          </div>
        </>
      }
    />
  )
}
